/** Locale para los nombres de país en el selector de teléfono. */
export const PHONE_COUNTRY_LOCALE = "es";

/** Países mostrados primero en el selector de teléfono (Ecuador por defecto). */
export const PREFERRED_PHONE_COUNTRIES = [
  "EC",
  "CO",
  "PE",
  "MX",
  "US",
  "ES",
  "AR",
  "CL",
  "PA",
  "VE",
  "BO",
  "PY",
  "UY",
  "CR",
  "GT",
  "HN",
  "NI",
  "SV",
  "DO",
  "PR",
];
